//https://gadymgicn3.execute-api.us-east-1.amazonaws.com/default/resume-parser
import axios from 'axios';
import { serverConfig } from './server-config';

export const ResumeService = {
    parseToJson: (data, parserResponseHandler, resume, setLoader) => {
        return axios.post(
            `https://${serverConfig.serverBaseAddress}/signite/resume/parse`,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('authToken')
                }
            }
        )
            .then((response) => {
                parserResponseHandler(response.data, resume);
            })
            .catch((error) => {
                console.error(error);
                setLoader && setLoader(false);
            });
    },

    scheduleCall: (candidateId, data, scheduleCallHanlder, setLoader) => {
        return axios.post(`https://1f5smpkr12.execute-api.us-east-1.amazonaws.com/default/schedule-call`, { candidateId: candidateId, candidateData: data }).then((response1) => {
            scheduleCallHanlder(response1.data);

        })
            .catch((error) => {
                console.error(error);
                setLoader && setLoader(false);
            });;
    }
}